export default function (plvName: string | undefined) {
  if (!plvName) {
    return "";
  }
  return (
    plvName
      ?.normalize("NFD")
      .replace(" ", "_")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[\s\.']+/g, "")
      .toLowerCase() ?? ""
  );
}
